import React from "react";

import { radioResources } from "../../../resources/radioResources";

export default function Radio({ resourceId }) {

    const resource = radioResources[resourceId];

    if (!resource) {
        return (
            <div className="radio">
                <div className="txt-fff">
                    Radio resource not found.
                </div>
            </div>
        );
    }

    return (
        <div className="radio">
            <div className="pt-20">
                {resource.content}
            </div>
        </div>
    );
}